import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const articleSlugs = [
  'hipobuy-spreadsheet',
  'kakobuy-spreadsheet',
  'cssbuy-spreadsheet',
  'superbuy-spreadsheet',
  'oopbuy-spreadsheet',
  'hipobuy-spreadsheet-safety',
  'hipobuy-spreadsheet-comparison',
  'hipobuy-spreadsheet-categories',
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide/",
    element: <ArticlePage />,
  },
  ...articleSlugs.map((slug): RouteObject => ({
    path: `/${slug}/`,
    element: <ArticlePage slug={slug} />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;